import React from 'react';
import {Modal, Radio} from "antd";
import {injectIntl} from "react-intl";
import SAInputLabel from "../../common/input/SAInputLabel";
import SAInputComponent from "../../common/input/SAInputComponent";
import SADatePicker from "../../common/input/SADatePicker";
import SATimePicker from "../../common/input/SATimePicker";
import Constants from "../../../services/Constants";
import moment from 'moment';
import Api from "../../../services/Api";
import {saveAs} from "file-saver";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class ManualRentalBookingModal extends React.Component {

  constructor(props){
    super(props);
    const {rentingCustomer, contractStart, contractEnd} = this.props.rentalDetails;
    this.state  ={
      errors:{},
      formData:{
        contractStartDate: contractStart ? moment(contractStart).format(Constants.DATE_FORMAT_API) : null,
        contractStartTime: contractStart ? moment(contractStart).format(Constants.TIME_FORMAT_API) : null,
        contractEndDate: contractEnd ? moment(contractEnd).format(Constants.DATE_FORMAT_API) : null,
        contractEndTime: contractEnd ? moment(contractEnd).format(Constants.TIME_FORMAT_API) : null,
        ...rentingCustomer},
    }
  }

  // componentWillReceiveProps = (nextProps)=>{
  //   if (nextProps.rentalDetails){
  //     const {rentingCustomer} = nextProps.rentalDetails
  //     this.setState({rentingCustomer});
  //   }
  // }

  handleDateChangeValue = (name, value) => {
    const formattedDate = value && moment(value).format(Constants.DATE_FORMAT_API);
    const {formData} = this.state;
    formData[name]=formattedDate;
    this.setState({formData});
  };
  handleChangeValue = (name, value) => {
    const {formData} = this.state;
    formData[name]=value;
    this.setState({formData});
  };

  handleChangeEvent = (event) => {
    const target = event.target;
    const value = (target.type === 'checkbox') ? target.checked : target.value;
    const name = target.name;
    this.handleChangeValue(name, value);
  };

  isDisabledDay = (currentDate) => {
    const {rentalAvailability, rentalVehicle} = this.props.rentalDetails;
    const selectedDay = currentDate.format(Constants.DATE_FORMAT_API);
    if (!rentalAvailability[selectedDay]){
      return true;
    }
    const isBooked = rentalAvailability[selectedDay].dayStatus === 'CLOSED' || ['NOT_AVAILABLE', 'RENTED', 'ASSIGNED'].includes(rentalAvailability[selectedDay].rentalStatus);
    return isBooked || (rentalVehicle.deactivationDate && currentDate.isAfter(moment(rentalVehicle.deactivationDate)));
  }
  onDateChange = (value, name) => {
    this.handleChangeValue(name, value);
  };

  onGenerateRentalContract = (evt, id) => {
    Api.get(`/generate/${id}/${evt.target.value}`).then(response=>{
        saveAs(response, document.name);
      }
    ).catch(error=>console.log(error));
  }

  onDelete = ()=>{
    const {rentalDetails} = this.props;
    this.props.onDelete(rentalDetails.id);
  }
  onSave = ()=>{
    const {formData} = this.state;

    const errors = {};

    if (!formData.firstName) {
      errors['firstName'] = {message: 'error.not.null'};
    }

    if (!formData.lastName) {
      errors['lastName'] = {message: 'error.not.null'};
    }
    if (!formData.from) {
      errors['from'] = {message: 'error.not.null'};
    }
    if (!formData.to) {
      errors['to'] = {message: 'error.not.null'};
    }
    if (moment(formData.from).isAfter(formData.to, 'day')){
      errors['to'] = {message: 'error.greater.or.equal', args:moment(formData.from).format(Constants.DATE_FORMAT_DISPLAY)};
    }

    if (!formData.contractStartDate) {
      errors['contractStartDate'] = {message: 'error.not.null'};
    }
    if (!formData.contractStartTime) {
      errors['contractStartTime'] = {message: 'error.not.null'};
    }
    if (!formData.contractEndDate) {
      errors['contractEndDate'] = {message: 'error.not.null'};
    }
    if (!formData.contractEndTime) {
      errors['contractEndTime'] = {message: 'error.not.null'};
    }

    formData.rentalVehicleId = this.props.rentalDetails.rentalVehicle.vehicleId;
    formData.rentalDetailsId = this.props.rentalDetails.id;

    this.setState({
      errors: errors,
      confirmLoading: false,
    });

    if (Object.keys(errors).length === 0) {
      this.props.onSave({...formData});
    }

  }
  render() {
    const {intl: {formatMessage}, rentalDetails, backendErrors, onModalClose, visible} = this.props;
    const {formData, errors} = this.state;

    const formErrors = (backendErrors && backendErrors.content) ? backendErrors.content : errors;

    if (!formData){
      return null;
    }

    return (
      <Modal title={formatMessage({id: 'section.car-park.modal.title'})}
             visible={visible} onCancel={onModalClose} footer={null}>
        <h3 className="box__subtitle">{formatMessage({id:'customer.details.title'})}</h3>

        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.firstname'} name={"firstName"} value={formData.firstName} error={formErrors['firstName']} onChange={this.handleChangeEvent} />
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputLabel label={'customer.lastname'} name={"lastName"} value={formData.lastName} error={formErrors['lastName']} onChange={this.handleChangeEvent}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
              <SAInputLabel label={'summary.phone'} name={"phone"} value={formData.phone} error={formErrors['phone']} onChange={this.handleChangeEvent} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent  label={formatMessage({id: 'placeholder.startDate'})}>
              <SADatePicker disabledDate={this.isDisabledDay} onChange={(value) => this.handleDateChangeValue('from', value)} value={formData.from} error={formErrors['from']}/>
            </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent  label={formatMessage({id: 'placeholder.endDate'})}>
              <SADatePicker disabledDate={this.isDisabledDay} onChange={(value) => this.handleDateChangeValue('to', value)} value={formData.to} error={formErrors['to']}/>
            </SAInputComponent>
          </div>
        </div>
        <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.contract-dates.title'})}</h3>

        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent  label={formatMessage({id: 'placeholder.startDate'})}>
              <SADatePicker onChange={(value) => this.handleDateChangeValue('contractStartDate', value)} value={formData.contractStartDate} error={formErrors['contractStartDate']}/>
            </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent label={formatMessage({id: 'placeholder.startTime'})}>
              <SATimePicker onChange={(value) => this.handleChangeValue('contractStartTime', value ? moment(value).format(Constants.TIME_FORMAT_API) : null)} value={formData.contractStartTime} error={formErrors['contractStartTime']}/>
            </SAInputComponent>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent label={formatMessage({id: 'placeholder.endDate'})}>
              <SADatePicker onChange={(value) => this.handleDateChangeValue('contractEndDate', value)} value={formData.contractEndDate} error={formErrors['contractEndDate']}/>
            </SAInputComponent>
          </div>
          <div className="col-md-6 col-xxl-6">
            <SAInputComponent label={formatMessage({id: 'placeholder.endTime'})}>
              <SATimePicker onChange={(value) => this.handleChangeValue('contractEndTime', value ? moment(value).format(Constants.TIME_FORMAT_API) : null)} value={formData.contractEndTime} error={formErrors['contractEndTime']}/>
            </SAInputComponent>
          </div>
        </div>

        {rentalDetails.id &&
          <React.Fragment>
        <h3 className="box__subtitle">{formatMessage({id:'rental-contract.download.title'})}</h3>
          <div className={"row"}>
          <div className="col-md-6 col-xxl-6">
            <RadioGroup >
              {Constants.SUPPORTED_LANGUAGES.map(lg=>
                <RadioButton value={lg} onClick={evt=>this.onGenerateRentalContract(evt, rentalDetails.id)}>{formatMessage({id:lg})}</RadioButton>
              )}
            </RadioGroup>
          </div>
          </div></React.Fragment>}
        <footer className="modal__footer">
          {rentalDetails.id && <button className="btn btn-sm btn-o-secondary" key="delete" onClick={this.onDelete}>{formatMessage({id: 'action.delete'})}</button>}
          <button className="btn btn-sm btn-primary" key="save" onClick={this.onSave}>{formatMessage({id: 'action.save'})}</button>
        </footer>
      </Modal>
    )
  }
}

export default injectIntl(ManualRentalBookingModal);



// WEBPACK FOOTER //
// ./src/components/carpark/parkplanning/ManualRentalBookingModal.js